export enum AnnouncementType {
    DEFAULT = 'default',
    WARNING = 'warning',
    URGENT = 'urgent',
}
